import { render } from "./PlanSaleSummaryCard.vue?vue&type=template&id=34ee624b"
import script from "./PlanSaleSummaryCard.vue?vue&type=script&lang=js"
export * from "./PlanSaleSummaryCard.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./PlanSaleSummaryCard.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_9f68edcb%2Fpackages%2Finsurer%2Fsrc%2Fcomponents%2Fplan_sales%2FPlanSaleSummaryCard.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__